import React from "react"
import types from "prop-types"
import clsx from "clsx"
import AuditableFilters from "./AuditableFilters"

const OptionsSidebar = ({ hiddenSidebar }) => (
  <div
    className={clsx("audit-trail-sidebar", hiddenSidebar && "hidden")}
  >
    <div className="audit-trail-sidebar-sticky">
      <AuditableFilters />
    </div>
  </div>
)

OptionsSidebar.propTypes = {
  hiddenSidebar: types.bool.isRequired,
}

export default OptionsSidebar
